import { useEffect, useState } from "react";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import usePaginator from "../../../../../../theme/Component/usePaginator";
import { Singleton } from "../../../../../../../core/services/Singleton";
import { _single } from "../../../../../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../../../theme/Component/BasicPage";
import { BasicButton } from "../../../../../../theme/Component/BasicButton";
import { BasicTable } from "../../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../../../theme/Component/ModalConfirm";
import { AccountEditor } from "../../../../../../editor/AccountEditor";
import { _OfficeUser } from "../../../../../../../core/services/dataBean/EntityCatalogVdos";
import { SelectRecurso } from "../../../../../../Factoty&Production/LabourType/SelectRecurso";
import { OfficeRoleEditor } from "./OfficeRoleEditor";



interface Props {
    idOffice: number;
}

export const OfficeUse = ({ idOffice }: Props) => {

    const OfficeUse = useDataBean(_OfficeUser);
    const paginador = usePaginator();
    const [Account, setAccount] = useState<any>(null)
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [form, setForm] = useState<any>({
        IDRole: null,
    })
    const [modaladd, setModaladd] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modaluser, setModaluser] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [idOffice, paginador.page])

    const getLista = () => {

        OfficeUse.instance.getOfficeUserCatalog(idOffice, Account, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    setLista(resp.List)
                }
            }
        )

    }
    const create = () => {
        setModaladd({ ...modaladd, "view": true });
    }
    const deleteItem = () => {
        OfficeUse.instance.deleteOfficeUser(OfficeUse.bean.IDOfficeUser).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }

    const addOfficeUser = () => {
        if (!OfficeUse.bean.IDAccount) {
            toast.warning("Debe seleccionar un Usuario.");
            return;
        }
        if (!OfficeUse.bean.IDOfficeRole) {
            toast.warning("Debe seleccionar un Rol.");
            return;
        }
        OfficeUse.instance.addOfficeUser(idOffice, OfficeUse.bean.IDOfficeRole, OfficeUse.bean.IDAccount, _single.getAccountID()).then(
            (resp: any) => {
                getLista();
                setModaladd({ ...modaladd, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        OfficeUse.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDOfficeUser', visible: true },
        { title: 'Usuario', property: 'AccountName', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (

        <div className="row">
            <div className="col-md-12">
                <label>Empleados de la Oficina</label>
            </div>
            <div className="col-md-6">
                <AccountEditor label="Beneficiario" idAccount={Account} onChange={(e) => { setAccount(e.IDAccount) }} />
            </div>
            <div className="col-md-6 mt-4 p-2">
                <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
            </div>
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={OfficeUse.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>

                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item {OfficeUse.bean.Name}</strong>
                </ModalConfirm>
            </div>
            <div className="col-md-12">
                <Modal modal={modaladd} updateModal={setModaladd} eventModal={addOfficeUser}>

                    <div className="row">
                        <div className="col-md-12">
                            <AccountEditor label="Beneficiario" idAccount={OfficeUse.bean.IDAccount} onChange={(e: any) => { OfficeUse.setBean({ ...OfficeUse.bean, "IDAccount": e.IDAccount }) }} />
                        </div>
                        <div className="col-md-12">
                            <OfficeRoleEditor idOffice={idOffice} render={OfficeUse.bean.RoleName} idSelector={OfficeUse.bean.IDOfficeRole} onChange={(e) => { OfficeUse.setBean({ ...OfficeUse.bean, "IDOfficeRole": e.IDOfficeRole, "RoleName": e.RoleName }) }} returnType="Object" />
                        </div>
                    </div>

                </Modal>
            </div>
        </div>

    )
}